import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, CalendarCheck2, Highlighter, ZoomIn } from "lucide-react";

const tools = [
  {
    to: "/student/productivity/ebook",
    title: "Life After 21 Days",
    subtitle: "BY PLANCOURR",
    desc: "Read the complete in-app ebook with page navigation, zoom controls, and personal highlights.",
    icon: BookOpen,
    accent: "bg-blue-50 text-blue-700 border-blue-100",
    meta: [
      { icon: ZoomIn, text: "Zoom reader" },
      { icon: Highlighter, text: "Highlight mode" },
    ],
  },
  {
    to: "/student/productivity/habits",
    title: "Habit Tracker",
    subtitle: "Daily consistency",
    desc: "Add habits, mark daily progress, and keep your streak visible while you study.",
    icon: CalendarCheck2,
    accent: "bg-emerald-50 text-emerald-700 border-emerald-100",
    meta: [
      { icon: CalendarCheck2, text: "Daily marks" },
      { icon: ArrowRight, text: "Streak view" },
    ],
  },
];

const StudentProductivityTools = () => (
  <div data-testid="student-productivity-tools">
    <div className="mb-8">
      <div className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-600">Productivity Tools</div>
      <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">Build your study rhythm</h1>
      <p className="mt-2 max-w-2xl text-slate-600">
        Read, reflect, and track small daily actions inside your student dashboard.
      </p>
    </div>

    <div className="grid gap-5 lg:grid-cols-2">
      {tools.map((tool) => (
        <Link
          key={tool.to}
          to={tool.to}
          className="group rounded-xl border border-slate-200 bg-white p-6 transition-all hover:-translate-y-0.5 hover:border-blue-200 hover:shadow-md"
        >
          <div className={`mb-5 flex h-12 w-12 items-center justify-center rounded-lg border ${tool.accent}`}>
            <tool.icon className="h-6 w-6" />
          </div>
          <div className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">{tool.subtitle}</div>
          <h2 className="mt-2 font-heading text-2xl font-bold text-slate-900">{tool.title}</h2>
          <p className="mt-3 text-sm leading-7 text-slate-600">{tool.desc}</p>
          <div className="mt-5 flex flex-wrap gap-2">
            {tool.meta.map((m) => (
              <span key={m.text} className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-semibold text-slate-600">
                <m.icon className="h-3.5 w-3.5" />
                {m.text}
              </span>
            ))}
          </div>
          <div className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-blue-700">
            Open tool <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </div>
        </Link>
      ))}
    </div>
  </div>
);

export default StudentProductivityTools;
